module.exports = __webpack_public_path__ + "img/c-sharp.82840a59.png";